import Vue from "vue";

const actions = {
  fetchTemplates() {
    return Vue.axios
      .get(`email-templates`)
      .then(response => response.data.data);
  },

  storeTemplate({ dispatch }, payload) {
    return Vue.axios.post(`email-templates`, payload).catch(error => {
      const response = error.response.data.error;

      dispatch(
        "snackBar",
        {
          message: response.message || response.fields.body[0],
          type: "is-danger",
          queue: false,
          duration: 10000
        },
        { root: true }
      );
    });
  },

  updateTemplate({ dispatch }, payload) {
    return Vue.axios
      .put(`email-templates/${payload.templateId}`, payload)
      .catch(error => {
        const response = error.response.data.error;

        dispatch(
          "snackBar",
          {
            message: response.message || response.fields.body[0],
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  deleteTemplate({ dispatch }, templateId) {
    return Vue.axios.delete(`email-templates/${templateId}`).catch(error => {
      dispatch(
        "snackBar",
        {
          message: error.response.data.error.message,
          type: "is-danger",
          queue: false,
          duration: 10000
        },
        { root: true }
      );
    });
  },

  sendEmails({ dispatch }, data) {
    return Vue.axios
      .post(`email-templates/${data.templateId}`, data.formData)
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message:
              Vue._.get(error, "response.data.error.message", false) ||
              Vue._.get(error, "response.data.error.fields.body[0]", false) ||
              "There was an error.  Please try again or contact wellness@be-engaged.co.",
            type: "is-danger"
          },
          { root: true }
        );

        throw error;
      });
  },

  superAdminSendMassEmail({ dispatch }, formData) {
    return Vue.axios.post(`super/mass-email`, formData).catch(error => {
      dispatch(
        "snackBar",
        {
          message:
            Vue._.get(error, "response.data.error.message", false) ||
            Vue._.get(error, "response.data.error.fields.body[0]", false) ||
            "There was an error.  Please try again or contact support@walkertracker.com.",
          type: "is-danger"
        },
        { root: true }
      );

      throw error;
    });
  }
};

export default actions;
